import { render, staticRenderFns } from "./phone-area.vue?vue&type=template&id=0cdc6d4b&scoped=true"
import script from "./phone-area.vue?vue&type=script&lang=js"
export * from "./phone-area.vue?vue&type=script&lang=js"
import style0 from "./phone-area.vue?vue&type=style&index=0&id=0cdc6d4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdc6d4b",
  null
  
)

export default component.exports